export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0d2efe99ed66b1b10d596d7daeb3a8a07f8dc5bf&name=fetchTypeahead!'